import router from '@/router';

router.addRoute({
	path: '/hotel/sadmin/checkbox-radio',
	name: 'CheckboxRadio',
	component: () => import('./View.vue'),
});
